/**
 * Ignore some yellowbox warnings. Some of these are for deprecated functions
 * that we haven't gotten around to replacing yet.
 */
import * as React from "react-native"

if (React.Platform.OS === 'web') {
  require("react-native").default = React
  React.Alert.alert = (title: string, message?: string, buttons?: React.AlertButton[], options?: React.AlertOptions) => {
    const confirmed = confirm(`${title}` + (message && `\n${message}` || ''))
    if (confirmed === false && buttons.length > 0) {
      buttons[0] && buttons[0].onPress && buttons[0].onPress()
    } else if (confirmed === true && buttons.length > 1) {
      buttons[1] && buttons[1].onPress && buttons[1].onPress()
    } else if (confirmed === true && buttons.length > 0) {
      buttons[0] && buttons[0].onPress && buttons[0].onPress()
    }
  }
}
